export const getById = (state, id) => state.filter(item => item.id === id)[0]
